const userDefaults = JSON.parse(localStorage.getItem("user")) || null;

// Identidad del sub-usuario (si aplica). Tiene: id, name, email, sub_role
const subUserDefaults = JSON.parse(localStorage.getItem("sub_user")) || null;

const state = {
  userRoot: userDefaults,
  // Cuando un sub-usuario inicia sesión, aquí va su identidad real (nombre, rol).
  // null = el usuario autenticado ES el anfitrión principal.
  subUser: subUserDefaults,
  token: localStorage.getItem("access_token") || null,
  loader: false,
  loaderMensaje: "Cargando ...",
  efecto: false,
  efectoMensaje: "Cargando ...",
  consumo: 0,
  stateProcess: 1,
  notificaciones: [],
  state_notificacion: false,
  propiedadActiva: Number(localStorage.getItem("propiedadActiva") || 0),
  selectPropertyView: localStorage.getItem("selectPropertyView") || false,
  datosModal: null,
  checkins: 0,
  idioma: localStorage.getItem("appLanguage"),
  demo: true,
  // colores
  colorOne: "#11b14d",
  colorTwo: "#22b0d5",
  colorTree: "#ffcb2d",
  colorFor: "#ebeef1",
  server: "http://localhost:8080/",

  // Datos nuevos de las reservas blobales  
  isVisibleModalBooking: false,
  selectedBookingRange: null,
  propertySelect: null,
  step: 1,
  // Total de pasos del asistente de creación (lo fija firstCreatePropiedad.vue).
  wizardTotal: 1,
  bookingToEdit: null,
  updateComplete: false,

  // Tipo de panel activo: 'apartment' | 'hotel'
  // Controlado por el switch en el dropdown del nav; persiste en localStorage.
  panelType: localStorage.getItem("wc_panel_type") || "apartment",
};

export default state;
